import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { format } from 'date-fns';
import { v4 as uuid } from 'uuid';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import { getDateWithoutTime } from '../../../shared/utils/smartutils';
import SchoolClassForm from './Form';
import {
  comChannelListByClass,
  schoolClassListByFilterQuery,
  schoolClassSaveMutation,
} from '../../../shared/queries/SchoolClass';
import { schoolTermEmployeeRelationshipForLoggedUser } from '../../../shared/queries/SchoolTermEmployeeRelation';
import { relationEmployeeClassBySchoolClassIdQuery } from '../../../shared/queries/RelationEmployeeClass';
import {
  relationStudentClassListRelatedByClass,
  relationStudentClassListToRelateByClassQuery,
} from '../../../shared/queries/RelationStudentClass';
import { courseListForSchoolClass } from '../../../shared/queries/Course';
import { academicCalendarListByFilterForTimetable } from '../../../shared/queries/AcademicCalendar';
import { shiftLabelValueListByFilter } from '../../../shared/queries/Shift';
import {
  findCurriculumByCouseStepWithWorkLoad,
  saveTimetableMutation,
  timetableGridBySchoolClass,
  timetableListBySchoolClass,
} from '../../../shared/queries/Timetable';
import { ACTIVE_TAB } from '../../../shared/utils/constants';
import Modal from '../../../shared/components/Modal';

const SchoolClass = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    active: true,
    singleClassShift: false,
  });
  const [formOn, setFormOn] = useState(false);
  const [relationStudentClassList, setRelationStudentClassList] = useState([]);
  const [activeEmployeesList, setActiveEmployeesList] = useState([]);
  const [academicCalendars, setAcademicCalendars] = useState([]);
  const [stepsByCourse, setStepsByCourse] = useState([]);
  const [schoolTerms, setSchoolTerms] = useState([]);
  const [courses, setCourses] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [timetable, setTimetable] = useState([]);
  const [disciplinesTimetable, setDisciplinesTimetable] = useState([]);
  const [registeredStudents, setRegisteredStudents] = useState([]);
  const [activeTab, setActiveTab] = useState(ACTIVE_TAB.ONE);
  const [selectedAcademicCalendar, setSelectedAcademicCalendar] = useState({});
  const [selectedClassShift, setSelectedClassShift] = useState({});
  const [timetableGrid, setTimetableGrid] = useState({});
  const [showWarningActiveStudents, setShowWarningActiveStudents] =
    useState(false);
  const [formValues, setFormValues] = useState();

  const backClickHandler = () => {
    history.push('/minime/turma');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleTab = (index) => {
    setActiveTab(index);
  };

  const getAcademicCalendar = (calendar) => {
    return calendar && calendar.id ? calendar : null;
  };

  const getShift = (shift) => {
    return shift && shift.id ? shift : null;
  };

  const loadSchoolTerms = () => {
    showLoading();
    const query = schoolTermEmployeeRelationshipForLoggedUser();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.schoolTermEmployeeRelationshipForLoggedUser =
          res.schoolTermEmployeeRelationshipForLoggedUser.filter(
            (item) => item.id > 0
          );
        res.schoolTermEmployeeRelationshipForLoggedUser =
          res.schoolTermEmployeeRelationshipForLoggedUser.map((item) => ({
            id: item.schoolTerm.id,
            name: item.schoolTerm.name,
            year: item.schoolTerm.year,
            value: item.schoolTerm.id,
            label: item.schoolTerm.name,
            initialDate: getDateWithoutTime(item.schoolTerm.initialDate),
            finalDate: getDateWithoutTime(item.schoolTerm.finalDate),
          }));
        setSchoolTerms(res.schoolTermEmployeeRelationshipForLoggedUser);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadActiveEmployees = (id = 0) => {
    showLoading();
    const query = relationEmployeeClassBySchoolClassIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        let relationEmployeeClass = res.relationEmployeeClassBySchoolClassId;
        if (relationEmployeeClass) {
          relationEmployeeClass = relationEmployeeClass.map((item) => ({
            ...item,
            value: item.employee.id,
            label: item.employee.name,
          }));
          const team = relationEmployeeClass.filter((item) => item.id > 0);
          setActiveEmployeesList(relationEmployeeClass);
          dispatch(change('SchoolClassForm', 'team', team));
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadStudentsToRelate = (term) => {
    showLoading();
    const termId = term ? term.id : 0;
    const query = relationStudentClassListToRelateByClassQuery(termId, dto.id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.relationStudentClassListToRelateByClass) {
          res.relationStudentClassListToRelateByClass =
            res.relationStudentClassListToRelateByClass.map((item) => ({
              ...item,
              value: item.student.id,
              label: `${item.student.fullName} (${item.schoolShift.name})`,
            }));
          setRelationStudentClassList(
            res.relationStudentClassListToRelateByClass
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadStudentsRelated = (classId) => {
    showLoading();
    const query = relationStudentClassListRelatedByClass(classId);
    GraphQL(query, {})
      .then((res) => {
        let relationStudentClass = res.relationStudentClassListRelatedByClass;
        if (relationStudentClass) {
          relationStudentClass = relationStudentClass.map((item) => ({
            ...item,
            value: item.student.id,
            label: `${item.student.fullName} (${item.schoolShift.name})`,
            initialDate: format(
              getDateWithoutTime(item.initialDateInMilli),
              'dd/MM/yyyy'
            ),
            finalDate: format(
              getDateWithoutTime(item.finalDateInMilli),
              'dd/MM/yyyy'
            ),
            activeDescription: item.active
              ? t('general.yesno.true')
              : t('general.yesno.false'),
          }));
          const registeredStudentsFilter = relationStudentClass.filter(
            (item) => item.id > 0
          );
          setRegisteredStudents(registeredStudentsFilter);
          hideLoading();
          dispatch(
            change(
              'SchoolClassForm',
              'registeredStudents',
              registeredStudentsFilter
            )
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadCommunicationChannels = () => {
    showLoading();
    const query = comChannelListByClass(dto.id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const comChannelList = res.comChannelListByClass.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        change('communicationChannels', comChannelList);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllCourses = () => {
    showLoading();
    const filter = {
      id: 0,
    };
    const query = courseListForSchoolClass(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.courseListByFilter = res.courseListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        const steps = res.courseListByFilter.map((item) => ({
          courseId: item.id,
          steps: item.steps,
        }));
        setStepsByCourse(steps);
        setCourses(res.courseListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllShifts = () => {
    showLoading();
    const filter = {
      id: 0,
      active: true,
      filterByStatus: true,
      updaterId: 0,
      classQuantity: 0,
    };
    const query = shiftLabelValueListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setShifts(res.shiftListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllAcademicCalendar = (term) => {
    showLoading();
    const termId = term ? term.id : 0;
    const filter = { schoolTerms: { id: termId } };
    const query = academicCalendarListByFilterForTimetable(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.academicCalendarListByFilter = res.academicCalendarListByFilter.map(
          (item) => ({
            ...item,
            value: item.id,
            label: item.name,
          })
        );
        setAcademicCalendars(res.academicCalendarListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const saveSchoolClass = (values) => {
    showLoading();
    const query = schoolClassSaveMutation(values);
    return GraphQL(query, {})
      .then(({ classSave }) => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        return classSave.id;
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
        hideLoading();
      });
  };

  const saveTimetable = (schoolClassId, values) => {
    showLoading();
    const query = saveTimetableMutation(schoolClassId, values);
    return GraphQL(query, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
        hideLoading();
      });
  };

  const findById = (id) => {
    showLoading();
    const filter = {
      studentsQuantity: 0,
      filterByStatus: false,
      updaterId: dto.id,
      year: 0,
      active: false,
      id,
      capacity: 0,
    };
    const getItemByIdQuery = schoolClassListByFilterQuery(filter);
    GraphQL(getItemByIdQuery, {})
      .then(async (res) => {
        hideLoading();
        const classList = res.classListByFilter;
        if (classList.length > 0) {
          const dtoAux = { ...classList[0] };
          await loadAllAcademicCalendar(dtoAux.term);
          await loadStudentsToRelate(dtoAux.term);
          await loadActiveEmployees(dtoAux.id);
          dtoAux.term = {
            ...dtoAux.term,
            value: dtoAux.term.id,
            label: dtoAux.term.name,
          };
          dtoAux.schoolGrade = {
            ...dtoAux.schoolGrade,
            value: dtoAux.schoolGrade.id,
            label: dtoAux.schoolGrade.name,
          };
          dtoAux.responsible =
            dtoAux.responsible.id > 0
              ? {
                  ...dtoAux.responsible,
                  value: dtoAux.responsible.id,
                  label: dtoAux.responsible.name,
                }
              : null;
          dtoAux.responsibleAux =
            dtoAux.responsibleAux && dtoAux.responsibleAux.id > 0
              ? {
                  ...dtoAux.responsibleAux,
                  value: dtoAux.responsibleAux.id,
                  label: dtoAux.responsibleAux.name,
                }
              : null;
          dtoAux.academicCalendar = getAcademicCalendar(
            dtoAux.academicCalendar
          );
          dtoAux.course = dtoAux.courseStep.course;
          dtoAux.classShift = getShift(dtoAux.classShift);
          dtoAux.enrollmentDate =
            new Date().getTime() > dtoAux.term.finalDate
              ? dtoAux.term.finalDate
              : new Date().getTime();
          loadStudentsRelated(dtoAux.id);
          setDto(dtoAux);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  };

  const curriculumByCourseStepWithWorkLoad = (courseStep) => {
    const query = findCurriculumByCouseStepWithWorkLoad(courseStep);
    return GraphQL(query, {})
      .then((res) => {
        return res.findCurriculumByCouseStepWithWorkLoad;
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  };

  const copyDisciplineToTimetableGrid = (disciplinesGrid, card) => {
    const found = disciplinesGrid.find(
      (item) => item.subject.id === card.subject.id
    );
    if (found) {
      const updatedTimetable = [...disciplinesGrid];
      const index = disciplinesGrid.findIndex(
        (item) => item.subject.id === found.subject.id
      );
      found.restStep -= 1;
      updatedTimetable[index] = found;
      setTimetable(updatedTimetable);
    }
    return found;
  };

  const loadTimetableGridBySchoolClass = (
    schoolId,
    courseStep,
    academicCalendarId,
    classShiftId,
    disciplinesGrid
  ) => {
    showLoading();
    const query = timetableGridBySchoolClass(
      schoolId,
      courseStep,
      academicCalendarId,
      classShiftId
    );
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const shiftMap = {};
        res.timetableGridBySchoolClass = res.timetableGridBySchoolClass.map(
          (item) => {
            return {
              weekday: item.weekDay,
              items: item.items.map((shift) => {
                if (shift.timetable.subject) {
                  const cardDiscipline = copyDisciplineToTimetableGrid(
                    disciplinesGrid,
                    shift.timetable
                  );
                  return {
                    ...shift,
                    shiftItem: {
                      ...shift.shiftItem,
                      card: { uuid: uuid(), ...cardDiscipline },
                      uuid: uuid(),
                    },
                    uuid: uuid(),
                  };
                }
                return {
                  ...shift,
                  shiftItem: {
                    ...shift.shiftItem,
                    card: { uuid: uuid() },
                    uuid: uuid(),
                  },
                  uuid: uuid(),
                };
              }),
            };
          }
        );
        res.timetableGridBySchoolClass.forEach((item) => {
          shiftMap[item.weekday] = item.items;
        });
        setTimetableGrid(shiftMap);
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  };

  const loadTimetableBySchoolClass = (
    schoolId,
    courseStep,
    subjectsWithWorkLoad
  ) => {
    const query = timetableListBySchoolClass(
      schoolId,
      courseStep,
      selectedClassShift.id
    );
    return GraphQL(query, {})
      .then((res) => {
        const disciplines = res.timetableListBySchoolClass.reduce(
          (acc, item) => acc.concat({ ...item.subject }),
          []
        );
        res.timetableListBySchoolClass = res.timetableListBySchoolClass.map(
          (item) => {
            const subjectWorkLoad = subjectsWithWorkLoad.find(
              (value) => value.subject.id === item.subject.id
            );
            return {
              ...item,
              stepWorkLoad: subjectWorkLoad ? subjectWorkLoad.stepWorkLoad : 0,
              restStep: subjectWorkLoad ? subjectWorkLoad.stepWorkLoad : 0,
            };
          }
        );
        setDisciplinesTimetable(disciplines);
        setTimetable(res.timetableListBySchoolClass);
        return res.timetableListBySchoolClass;
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  };

  const loadDataTimetableBySchoolClass = async (schoolId, courseStep) => {
    const subjectsWithWorkLoad = await curriculumByCourseStepWithWorkLoad(
      courseStep
    );
    const disciplinesGrid = await loadTimetableBySchoolClass(
      schoolId,
      courseStep,
      subjectsWithWorkLoad
    );
    await loadTimetableGridBySchoolClass(
      schoolId,
      courseStep,
      selectedAcademicCalendar.id,
      selectedClassShift.id,
      disciplinesGrid
    );
  };

  const loadAllData = async () => {
    await loadAllShifts();
    await loadAllCourses();
    await loadSchoolTerms();
    await loadCommunicationChannels();
  };

  const toggleShowWarningActiveStudents = () => {
    setShowWarningActiveStudents(!showWarningActiveStudents);
  };

  const hasEnrolled = (enrolled) => {
    return enrolled.length && enrolled.some((registered) => registered.active);
  };

  const handleSubmit = async (values) => {
    if (
      !values.active &&
      !showWarningActiveStudents &&
      hasEnrolled(values.registeredStudents)
    ) {
      setFormValues(values);
      toggleShowWarningActiveStudents();
    } else {
      if (showWarningActiveStudents) {
        toggleShowWarningActiveStudents();
      }
      const schoolClassId = await saveSchoolClass(values);
      if (values.cardsSubjects && values.cardsSubjects.length) {
        saveTimetable(schoolClassId, values);
      }
      backClickHandler();
    }
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        loadAllData().then(() => findById(parseInt(match.params.id, 0)));
      } else {
        setFormOn(true);
      }
    } else {
      loadAllData().then(() => {
        loadActiveEmployees();
        setFormOn(true);
      });
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.turma')}>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.inactive-class')}
        toggle={toggleShowWarningActiveStudents}
        modal={showWarningActiveStudents}
        onConfirm={() => handleSubmit(formValues)}
      />
      {formOn && (
        <SchoolClassForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          schoolTerms={schoolTerms}
          activeEmployeesList={activeEmployeesList}
          relationStudentClassList={relationStudentClassList}
          loadStudentsToRelate={loadStudentsToRelate}
          loadAllAcademicCalendar={loadAllAcademicCalendar}
          changeRelationStudentClassList={setRelationStudentClassList}
          dispatch={dispatch}
          courses={courses}
          shifts={shifts}
          stepsByCourse={stepsByCourse}
          academicCalendars={academicCalendars}
          activeTab={activeTab}
          toggleTab={toggleTab}
          disciplinesTimetable={disciplinesTimetable}
          timetable={timetable}
          loadTimetableBySchoolClass={loadDataTimetableBySchoolClass}
          setRegisteredStudents={setRegisteredStudents}
          registeredStudents={registeredStudents}
          setSelectedAcademicCalendar={setSelectedAcademicCalendar}
          selectedAcademicCalendar={selectedAcademicCalendar}
          setSelectedClassShift={setSelectedClassShift}
          selectedClassShift={selectedClassShift}
          timetableGrid={timetableGrid}
          setTimetableGrid={setTimetableGrid}
        />
      )}
    </SmartCard>
  );
};

SchoolClass.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolClass)
);
